module.exports = __webpack_public_path__ + "img/propsht.e964313.png";